import _ from "lodash";
import { useState } from "react";

const useFilterTransactionsByEntities = (entities: string[]) => {
	const [filtersSelected, setFiltersSelected] = useState<string[]>([]);
	const [filterName, setFilterName] = useState<string>("");

	const onSelectFilter = (filter: string) => {
		const index = filtersSelected.indexOf(filter);
		if (index === -1) setFiltersSelected([...filtersSelected, filter]);
		else setFiltersSelected(filtersSelected.filter((i) => i !== filter));
	};

	const onFilterName = (filter: string) => {
		setFilterName(filter);
	};

	return {
		filtersSelected,
		onSelectFilter,
		entities: _.uniq(entities),
		filterName,
		onFilterName
	};
};

export default useFilterTransactionsByEntities;
